$shm_projects_module_card $mol_view
	module_id \
	project_id \
	sub /
		<= Title $mol_link
			title <= module_id
			arg <= module_arg *
		<= Description $mol_text text <= description \
